import { useState } from "react";
import instance from "../../../Interceptor/api_instance";
import { SpinnerOverlay } from "../../../Components/LoadingAnimations/SpinnerOverlay";
import { toDatetimeLocal } from "../../../Helper/FormatDatetimes";
import { useTranslation } from "react-i18next";
import { ActionResponse } from "../../../Components/Modals/ActionResponses";
import FormBlock from "../../../Components/Inputs/FormBlock";
import LocationSearch from "../../../Components/Inputs/LocationSearch";

const EditMaintenanceReport = ({ data, setData, close }) => {
  const { t } = useTranslation();
  const [responseModal, setResponseModal] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    status: data.status,
    id: data.id,
    expected_date: toDatetimeLocal(data.expected_date),
    notes: data.notes,
    priority: data.priority,
    odometer: data.odometer,
    location: {
      value: data.location.id,
      label: data.location.loc_name,
    },
    assigned_spot: data.assigned_spot || "",
  });
  const updateFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await instance.patch(
        `safety/update-maintenance-report`,
        { ...formData, location: formData.location.value },
      );
      if (response.status === 200) {
        setResponseModal({
          status: t("forms.type.success"),
          message: t("forms.responses.success"),
        });
        setData((prev) => ({
          ...prev,
          status: response.data.status,
          expected_date: toDatetimeLocal(response.data.expected_date),
          notes: response.data.notes,
          odometer: response.data.odometer,
          priority: response.data.priority,
          location: response.data.location,
          assigned_spot: response.data.assigned_spot,
        }));
      }
    } catch (error) {
      setResponseModal({
        status: "Error",
        message: error,
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="page-mask page-mask-animation">
      {isLoading && <SpinnerOverlay />}
      {responseModal && (
        <ActionResponse
          status={responseModal.status}
          message={responseModal.message}
          close={() => {
            if (responseModal.status === t("forms.type.success")) {
              close();
            } else {
              setResponseModal(null);
            }
          }}
        />
      )}
      <div className="new-modal">
        <h3 className="global-h3">{t("buttons.edit-report")}</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-block">
            <label className="input-label required">
              {t("yard-tables.table-columns.status")}
            </label>
            <div className="input-cont">
              <select
                className="text-input with-border"
                onChange={updateFormData}
                name="status"
                value={formData.status}
                required
              >
                <option value="open">
                  {t("forms.type.maintenance-report.status-options.open")}
                </option>
                <option value="in-shop">
                  {t("forms.type.maintenance-report.status-options.in-shop")}
                </option>
                <option value="inspection">
                  {t("forms.type.maintenance-report.status-options.inspection")}
                </option>
                <option value="waiting-parts">
                  {t(
                    "forms.type.maintenance-report.status-options.waiting-parts",
                  )}
                </option>
                <option value="in-progress">
                  {t(
                    "forms.type.maintenance-report.status-options.in-progress",
                  )}
                </option>
                <option value="tasks-completed">
                  {t("statuses.tasks-completed")}
                </option>
                {data.status === "completed" && (
                  <option value="completed">
                    {t("forms.type.maintenance-report.status-options.completed")}
                  </option>
                )}
              </select>
            </div>
          </div>
          <div className="form-block">
            <label className="input-label required">
              {t("yard-tables.table-columns.priority")}
            </label>
            <div className="input-cont">
              <select
                className="text-input with-border"
                onChange={updateFormData}
                name="priority"
                value={formData.priority}
                required
              >
                <option value={"3"}>
                  {t("forms.type.maintenance-report.priorityOptions.normal")}
                </option>
                <option value={"2"}>
                  {t("forms.type.maintenance-report.priorityOptions.important")}
                </option>
                <option value={"1"}>
                  {t("forms.type.maintenance-report.priorityOptions.urgent")}
                </option>
              </select>
            </div>
          </div>
          <div className="form-block">
            <label className="required">
              {t("yard-tables.table-columns.location")}
            </label>
            <div className="input-cont">
              <LocationSearch
                selectedOption={formData.location}
                onSelect={(option) =>
                  setFormData((prev) => ({
                    ...prev,
                    location: option,
                  }))
                }
              />
            </div>
          </div>
          <div className="form-block">
            <label className="">{t("general.spot")}</label>
            <div className="input-cont">
              <input
                className="text-input with-border"
                type="text"
                onChange={updateFormData}
                value={formData.assigned_spot}
                name="assigned_spot"
              />
            </div>
          </div>
          {data.truck && (
            <FormBlock
              label={"Odometer"}
              value={formData.odometer}
              update={updateFormData}
              type={"number"}
              name={"odometer"}
              placeholder={0}
            />
          )}
          <div className="form-block">
            <label className="input-label">
              {t("forms.type.maintenance-report.labels.due-date")}
            </label>
            <div className="input-cont">
              <input
                className="text-input with-border"
                type="datetime-local"
                onChange={updateFormData}
                value={formData.expected_date}
                name="expected_date"
              />
            </div>
          </div>
          <div className="form-block">
            <label className="input-label">
              {t("forms.type.vehicle.input-headers.notes")}
            </label>
            <div className="input-cont">
              <textarea
                className="text-input with-border"
                style={{ resize: "vertical", height: "150px" }}
                onChange={updateFormData}
                name="notes"
                value={formData.notes}
              ></textarea>
            </div>
          </div>
          <div className="full-cont">
            <button className="change-pwd-btn" type="submit">
              {t("buttons.submit")}
            </button>
            <button
              className="all-btn cancel-btn"
              type="button"
              onClick={close}
            >
              {t("buttons.cancel")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditMaintenanceReport;
